var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGovernanceScoreActivity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66669 16.666H18.3334V18.3327H1.66669V16.666ZM3.33335 9.99935H5.00002V15.8327H3.33335V9.99935ZM7.50002 9.99935H9.16669V15.8327H7.50002V9.99935ZM10.8334 9.99935H12.5V15.8327H10.8334V9.99935ZM15 9.99935H16.6667V15.8327H15V9.99935ZM1.66669 5.83268L10 1.66602L18.3334 5.83268V9.16602H1.66669V5.83268ZM10 6.66602C10.4603 6.66602 10.8334 6.29292 10.8334 5.83268C10.8334 5.37245 10.4603 4.99935 10 4.99935C9.53977 4.99935 9.16669 5.37245 9.16669 5.83268C9.16669 6.29292 9.53977 6.66602 10 6.66602Z",
    fill: "#9CA2A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernanceScoreActivity);
export default __webpack_public_path__ + "static/media/governance-score-activity.aac82000ce08350d7ed33e94f4dc8f2d.svg";
export { ForwardRef as ReactComponent };